import { AccidentAtlasChartConfig } from './api'

export type AccidentAtlasChartRenderType =
  | 'PieChart'
  | 'ColumnChart'
  | 'LineChart'

export type AccidentAtlasTileDisplayKind = 'text' | 'chart'

export type AccidentAtlasTileChart = {
  config: AccidentAtlasChartConfig
  renderType: AccidentAtlasChartRenderType
}

/** CMS tile (matches ContentfulModuleAccidentAtlasTile content fields) */
export type AccidentAtlasCmsTile = {
  tileId: string
  frontHeadline?: string
  frontCopy?: RvG.Contentful.BasicRichTextType
  frontHighlightText?: string
  backHeadline?: string
  backCopy?: RvG.Contentful.BasicRichTextType
  backCta?: RvG.Contentful.BasicRichTextType | string
}

/** Processed tile for the UI (CMS + API data for the selected region) */
export type AccidentAtlasTileView = AccidentAtlasCmsTile & {
  displayKind: AccidentAtlasTileDisplayKind
  charts: AccidentAtlasTileChart[]
}

export type TileProps = RvG.IReactDefaultProps &
  AccidentAtlasTileView & {
    /** Narrow tile layout: paginate column charts with more than five bars */
    compactChartLayout?: boolean
  }

export function toAccidentAtlasCmsTiles(
  tiles?: Array<
    Pick<
      RvG.Contentful.IContentfulModuleAccidentAtlasTile,
      | 'tileId'
      | 'frontHeadline'
      | 'frontHighlightText'
      | 'frontCopy'
      | 'backHeadline'
      | 'backCopy'
      | 'backCta'
    >
  >
): AccidentAtlasCmsTile[] | undefined {
  return tiles?.map(
    ({
      tileId,
      frontHeadline,
      frontHighlightText,
      frontCopy,
      backHeadline,
      backCopy,
      backCta,
    }) => ({
      tileId,
      frontHeadline,
      frontCopy,
      backHeadline,
      backCopy,
      backCta,
      ...(frontHighlightText ? { frontHighlightText } : {}),
    })
  )
}
